import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { brandColors } from '../../theme';
import type { ArchivedIdea } from '../../types/ideaBoard';

interface ArchivedIdeaCardProps {
  idea: ArchivedIdea;
}

const ArchivedIdeaCard: React.FC<ArchivedIdeaCardProps> = ({ idea }) => {
  const dealtWithDate = new Date(idea.dealtWithAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 1.5,
        borderColor: 'divider',
        opacity: 0.85,
      }}
    >
      <CardContent sx={{ pb: '12px !important' }}>
        <Typography variant="body1" sx={{ color: brandColors.darkGray, mb: 1.5, lineHeight: 1.6 }}>
          {idea.rewrittenEnglishSummary}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            label={idea.category}
            size="small"
            sx={{
              backgroundColor: `${brandColors.blue}15`,
              color: brandColors.blue,
              fontWeight: 500,
              fontSize: '0.75rem',
            }}
          />
          <Chip
            label="Completed"
            size="small"
            color="success"
            sx={{ fontWeight: 500, fontSize: '0.75rem' }}
          />
          <Typography variant="caption" sx={{ color: brandColors.mediumGray }}>
            Dealt with {dealtWithDate}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ArchivedIdeaCard;
